import React from 'react'

import Icon from '@/components/common/Icon'

const IconFacebook: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 32 33"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g clipPath="url(#clip0_279_1385)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 32.3058C26.1491 31.1056 32 24.4861 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 24.4861 5.85093 31.1056 13.5 32.3058V21.125H9.4375V16.5H13.5V12.975C13.5 8.96563 15.8875 6.75 19.5438 6.75C21.2938 6.75 23.125 7.0625 23.125 7.0625V11H21.1063C19.1188 11 18.5 12.2344 18.5 13.5V16.5H22.9375L22.2281 21.125H18.5V32.3058Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_279_1385">
        <rect y="0.5" width="32" height="32" rx="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconFacebook)
